// HBB.js
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import hbb_banner_img from "../../assets/hbb_banner_element.png";
import hbb_grid_1 from "../../assets/hbb_grid_1.png";
import hbb_grid_2 from "../../assets/hbb_grid_2.png";
import hbb_grid_3 from "../../assets/hbb_grid_3.png";
import hbb_grid_4 from "../../assets/hbb_grid_4.png";
import hbb_grid_5 from "../../assets/hbb_grid_5.png";
import hbb_grid_6 from "../../assets/hbb_grid_6.png";
import hbb_grid_7 from "../../assets/hbb_grid_7.png";
import hbb_grid_8 from "../../assets/hbb_grid_8.png";
import deskphone from "../../assets/custom-icons/deskphone.png";
import hourglass_bottom from "../../assets/custom-icons/hourglass_bottom.png";
import manufacturing from "../../assets/custom-icons/manufacturing.png";
import network_wifi from "../../assets/custom-icons/network_wifi.png";
import stadia_controller from "../../assets/custom-icons/stadia_controller.png";
import account_balance_wallet from "../../assets/custom-icons/account_balance_wallet.png";
import compass_calibration from "../../assets/custom-icons/compass_calibration.png";

const HbbHome = () => {
  const navigate = useNavigate();

  return (
    <>
      <main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-3">
        <section className="relative py-12 px-6 rounded-lg overflow-hidden bg-[rgba(25,172,151,0.63)]">
          {/* Round partition with radial gradient */}
          <div className="circular-elements"></div>
          <div className="relative z-10 max-w-7xl mx-auto text-left flex items-center justify-between">
            <div>
              <h3 className="text-4xl font-extrabold mb-2 text-[rgba(184,247,255,0.98)]">
                Our Home <br />
                Broadband
              </h3>
              <p className="text-xs mb-6 leading-tight sm:text-sm w-[60%] text-[rgba(184,247,255,0.98)]">
                Switch to our Home Broadband and we'll credit your new account
                with the amount on your final bill from your old provider - up
                to £100. Plus get a £50 gift card with all 24-month plans.
              </p>
              <button
                className="bg-[#FFFFFF] text-[#5A949A] px-4 py-3 rounded-md font-bold text-sm flex items-center gap-2"
                onClick={() => {
                  navigate("/coverageChecker");
                  console.log("Navigating to coverage checker");
                }}
              >
                <span>Check Coverage</span>
                <img src={compass_calibration} alt="" className="h-5 w-auto" />
              </button>
            </div>
            <div className="flex-shrink-0 hidden sm:block">
              <img
                src={hbb_banner_img} // Replace with actual image URL or local asset
                alt="Broadband Device"
                className="w-[350px] md:w-[400px] lg:w-[420px] h-auto absolute right-[-120px] bottom-[-120px] lg:bottom-[-150px]"
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/200x150?text=Image+Not+Found"; // Fallback image
                }}
              />
            </div>
          </div>
        </section>

        {/* 4-Part Grid Section */}
        <section className="mt-6 mb-6 pt-0">
          <h2 className="text-2xl font-bold text-[#3C8086] mb-4 pt-0 text-left">
            Why try Three Broadband?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Grid Item 1 */}
            <div className="relative rounded-lg overflow-hidden group">
              <img
                src={hbb_grid_1}
                alt="Broadband Device"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute top-1/2 left-0 right-0 p-6 flex flex-col">
                <h2 className="text-lg font-bold text-black mb-2 text-left">
                  Lightning Fast Speeds
                </h2>
                <p className="text-sm text-gray-700 text-left">
                  Experience ultra-fast broadband with speeds up to 1Gbps
                </p>
              </div>
            </div>

            {/* Grid Item 2 */}
            <div className="relative rounded-lg overflow-hidden group">
              <img
                src={hbb_grid_2}
                alt="Secure Connection"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute top-1/2 left-0 right-0 p-6 flex flex-col">
                <h3 className="text-lg font-bold text-black mb-2 text-left">
                  Secure Connection
                </h3>
                <p className="text-sm text-gray-700 text-left">
                  Advanced security features to keep your connection safe
                </p>
              </div>
            </div>

            {/* Grid Item 3 */}
            <div className="relative rounded-lg overflow-hidden group">
              <img
                src={hbb_grid_3}
                alt="24/7 Support"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute top-1/2 left-0 right-0 p-6 flex flex-col">
                <h3 className="text-lg font-bold text-black mb-2 text-left">
                  24/7 Support
                </h3>
                <p className="text-sm text-gray-700 text-left">
                  Round-the-clock customer service for all your needs
                </p>
              </div>
            </div>

            {/* Grid Item 4 */}
            <div className="relative rounded-lg overflow-hidden group">
              <img
                src={hbb_grid_4}
                alt="No Price Hikes"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute top-1/2 left-0 right-0 p-6 flex flex-col">
                <h3 className="text-lg font-bold text-black mb-2 text-left">
                  No Price Hikes
                </h3>
                <p className="text-sm text-gray-700 text-left">
                  Fixed prices with no mid-contract increases
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="mt-6 mb-6 mr-4 pt-0">
          <h2 className="text-2xl font-bold text-[#3C8086] mb-4 pt-0 text-left">
            Great ways to use Three Broadband
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-6">
            {/* Grid Item 5 */}
            <div className="relative rounded-lg overflow-hidden group h-60">
              <img
                src={hbb_grid_5}
                alt="Moving House"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute top-1/2 left-0 transform -translate-y-1/2 w-[60%] p-4 rounded-lg">
                <div className="w-full text-left pl-0">
                  <h2 className="text-2xl leading-none font-bold text-[#3C8086] mb-2">
                    Moving house? Get connected on day one
                  </h2>
                  <p className="text-xs text-[rgba(20, 140, 150, 1)]">
                    You don’t have to wait to get connected when you move. We’ll
                    send your broadband hub with next day delivery – to your old
                    or your new address. Just plug it in and you can get
                    connected before you’ve even got the sofa through the door.
                  </p>
                </div>
              </div>
            </div>

            {/* Grid Item 6 */}
            <div className="relative rounded-lg overflow-hidden group">
              <img
                src={hbb_grid_6}
                alt="Set Up Wi-Fi"
                className="w-full h-60 object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute top-1/2 left-0 transform -translate-y-1/2 w-[60%] p-4 rounded-lg">
                <div className="w-full text-left">
                  <h3 className="text-2xl leading-none font-bold text-[#3C8086] mb-2">
                    Set up Wi-Fi in your mega shed{" "}
                  </h3>
                  <p className="text-xs text-[rgba(20, 140, 150, 1)]">
                    Built a big shed for a home office, man cave, crafts space,
                    or something else? Then get your own connection outside. All
                    you need is a mains socket and our network – you don’t need
                    to lay down any extra lines or cables.
                  </p>
                </div>
              </div>
            </div>

            {/* Grid Item 7 */}
            <div className="relative rounded-lg overflow-hidden group">
              <img
                src={hbb_grid_7}
                alt="Solve Phone Line"
                className="w-full h-60 object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute top-1/2 left-0 transform -translate-y-1/2 w-[60%] p-4 rounded-lg">
                <div className="w-full text-left">
                  <h3 className="text-2xl leading-none font-bold text-[#3C8086] mb-2">
                    Solve your phone line and cable problems{" "}
                  </h3>
                  <p className="text-xs text-[rgba(20, 140, 150, 1)]">
                    Old phone lines can limit where you get the best connection.
                    Our broadband hub lets you plug in anywhere, no old wires
                    needed.
                  </p>
                </div>
              </div>
            </div>

            {/* Grid Item 8 */}
            <div className="relative rounded-lg overflow-hidden group">
              <img
                src={hbb_grid_8}
                alt="Second Connection"
                className="w-full h-60 object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute top-1/2 left-0 transform -translate-y-1/2 w-[60%] p-4 rounded-lg">
                <div className="w-full text-left">
                  <h3 className="text-2xl leading-none font-bold text-[#3C8086] mb-2">
                    Get a second connection just for you{" "}
                  </h3>
                  <p className="text-xs text-[rgba(20, 140, 150, 1)]">
                    Keep losing Zoom calls because everyone’s online? Our 5G
                    broadband lets you set up a second connection for steady,
                    high-speed internet—perfect for work or gaming.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="mt-6 mb-6 mr-4 pt-0">
          <h2 className="text-2xl font-bold text-[#3C8086] mb-4 pt-0 text-left">
            Why Three Home Broadband?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-6">
            {/* Grid Item 1 */}
            <div className="rounded-lg overflow-hidden group h-60 bg-white border border-gray-300 p-4">
              <div className="flex items-center mb-3">
                <img src={deskphone} alt="" className="h-6 w-6 mr-2" />
                <h3 className="text-lg font-bold text-[#3C8086]">
                  No landline
                </h3>
              </div>
              <p className="text-sm text-[rgba(0,0,0,0.7)] text-left">
                No landline? No problem. Our super-fast broadband is available
                where you simply don't want a landline or are unable to get a
                landline where you are—we've got you covered.
              </p>
            </div>

            {/* Grid Item 2 */}
            <div className="rounded-lg overflow-hidden group h-60 bg-white border border-gray-300 p-4">
              <div className="flex items-center mb-3">
                <img src={manufacturing} alt="" className="h-6 w-6 mr-2" />
                <h3 className="text-lg font-bold text-[#3C8086]">
                  No engineer
                </h3>
              </div>
              <p className="text-sm text-[rgba(0,0,0,0.7)] text-left">
                As Three broadband doesn't require a fixed line to work, you
                won't need to wait days or weeks for an engineer to come along
                and install one.
              </p>
            </div>

            {/* Grid Item 3 */}
            <div className="rounded-lg overflow-hidden group h-60 bg-white border border-gray-300 p-4">
              <div className="flex items-center mb-3">
                <img src={hourglass_bottom} alt="" className="h-6 w-6 mr-2" />
                <h3 className="text-lg font-bold text-[#3C8086]">No waiting</h3>
              </div>
              <p className="text-sm text-[rgba(0,0,0,0.7)] text-left">
                With next-day delivery, you can get connected to your Three
                broadband hub, be it for your new or old power source—connect to
                the UK's fastest 5G network in minutes.
              </p>
            </div>

            {/* Grid Item 4 */}
            <div className="rounded-lg overflow-hidden group h-60 bg-white border border-gray-300 p-4">
              <div className="flex items-center mb-3">
                <img
                  src={account_balance_wallet}
                  alt=""
                  className="h-6 w-6 mr-2"
                />
                <h3 className="text-lg font-bold text-[#3C8086]">
                  30-day money-back
                </h3>
              </div>
              <p className="text-sm text-[rgba(0,0,0,0.7)] text-left">
                There's no service, and we're so confident in our service we're
                proud to offer a 30-day money-back guarantee. Added peace of
                mind for you and a bit of extra money saved. Happy days!
              </p>
            </div>

            {/* Grid Item 5 */}
            <div className="rounded-lg overflow-hidden group h-60 bg-white border border-gray-300 p-4">
              <div className="flex items-center mb-3">
                <img src={stadia_controller} alt="" className="h-6 w-6 mr-2" />
                <h3 className="text-lg font-bold text-[#3C8086]">
                  Perfect for Gaming
                </h3>
              </div>
              <p className="text-sm text-[rgba(0,0,0,0.7)] text-left">
                Get your game face on. Truly unlimited data, ultra-fast
                downloads, 4K streaming capabilities, Wi-Fi technology and
                beyond. It's plug and play broadband for gaming and beyond,
                ideal for exceptional gaming experiences.
              </p>
            </div>

            {/* Grid Item 6 */}
            <div className="rounded-lg overflow-hidden group h-60 bg-white border border-gray-300 p-4">
              <div className="flex items-center mb-3">
                <img src={network_wifi} alt="" className="h-6 w-6 mr-2" />
                <h3 className="text-lg font-bold text-[#3C8086]">
                  Whole home Wi-Fi
                </h3>
              </div>
              <p className="text-sm text-[rgba(0,0,0,0.7)] text-left">
                Get great Wi-Fi across your whole home with Three home broadband
                and eero mesh Wi-Fi. Solve blackspots and buffering, hello to
                stable, fast, reliable coverage and greater connectivity for
                even more of your devices. From bedroom to bathroom and beyond.
              </p>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default HbbHome;
